import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that wraps product badges (format + certification labels)
 * and updates them on variant change.
 */
class ProductBadgesOverlay extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const source = event.detail.data.html;
    if (!source) return;

    const newOverlay = source.querySelector('product-badges-overlay');
    if (!newOverlay) return;

    this.replaceWith(newOverlay);
  };
}

if (!customElements.get('product-badges-overlay')) {
  customElements.define('product-badges-overlay', ProductBadgesOverlay);
}
